<script setup lang="ts">
const staticLinks = useStaticLinks()
</script>

<template>
    <nuxt-link :to="staticLinks.support" target="_blank">
        <slot>{{ $t('contact-form') }}</slot>
    </nuxt-link>
</template>